/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PerformTrace/view.blocks to change it.
import CloseAction from './CloseAction/index'
import Content from './Content/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PerformTrace({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CephTracing/PerformTrace"
  
}) {
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 width="95vw"
 height="95vh"
>
{childProps => (
<React.Fragment>
<div
  data-testid="PerformTrace.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="X Ray Cephalometric Analysis"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}